import { render } from "./EmailDomainManager.vue?vue&type=template&id=7aa20d1f&scoped=true&ts=true"
import script from "./EmailDomainManager.vue?vue&type=script&lang=ts"
export * from "./EmailDomainManager.vue?vue&type=script&lang=ts"

import "./EmailDomainManager.vue?vue&type=style&index=0&id=7aa20d1f&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aa20d1f"]])

export default __exports__